/*
 * @Date: 2024-06-25 18:37:50
 * @Author: miroku.yang
 * @Description:
 */
import React from 'react'
import { Button } from 'antd'
import { IconSvg } from '..'
import { useTranslation } from '@/libs/next-lang'
import { HOME_PATH } from '@/constants'
import styles from './styles.module.less'

interface IProps {
  children: any
}

interface IState {
  hasError: boolean
  errorInfo: any
}

function ErrorContent({ errorInfo, onRefresh }) {
  const { t } = useTranslation(['components'])

  return (
    <div className={styles['error-boundary-comp-wrapper']}>
      <div className={styles['error-boundary-container']}>
        <div className={styles.title}>
          <span>{t('components:t24')}</span>
        </div>
        <Button
          type="primary"
          icon={<IconSvg type="icon-ico_yijiantihuan" />}
          onClick={onRefresh}
          className={styles['refresh-button']}
        >
          {t('components:t25')}
        </Button>
        <div className={styles['error-info']}>
          <pre>
            <code>{JSON.stringify(errorInfo || {})}</code>
          </pre>
        </div>
      </div>
    </div>
  )
}

export default class Index extends React.Component<IProps, IState> {
  static getDerivedStateFromError() {
    return { hasError: true }
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      hasError: false,
      errorInfo: {},
    }
  }

  componentDidCatch(err: Error) {
    this.setState({ errorInfo: err.message })
  }

  onRefresh = () => {
    window.location.href = HOME_PATH
  }

  render() {
    if (this.state.hasError) {
      return <ErrorContent errorInfo={this.state.errorInfo} onRefresh={this.onRefresh} />
    }
    return this.props.children
  }
}
